import { Form, Select, Button, DatePicker, Segmented } from "antd";
import find from "lodash/find";
import map from "lodash/map";
import get from "lodash/get";
import dayjs from "dayjs";
import {
  getCurrentDateRange,
  customWeekStartEndFormat,
} from "../../../utilities/report";

import { getButtonDisabled } from "../../../utilities/helpers";
import { BREAKDOWN_PERMISSION } from "../../../constants";

const dateFormat = "YYYY-MM-DD";
const HeaderSelector = ({
  filter,
  config,
  form,
  setFilters,
  setConfig,
  getTemplates,
  getDetails,
  setStatsConfig
}) => {
  const companies = get(config, "companies", [])
  .filter(company =>
    find(get(company, "feature_permissions", []), ['key', BREAKDOWN_PERMISSION])
  )
  .map(company => ({
    label: get(company, "name"),
    value: get(company, "id"),
  }));
  return (
    <div className="w-full px-8 py-6">
      <div className="justify-start flex items-center h-full space-x-5">
        <Form.Item
          name="Company"
          label="Company"
          colon={false}
          layout="vertical"
        >
          <Select
            style={{ minWidth: 250 }}
            size="middle"
            value={get(filter, "company")}
            placeholder="Select Company"
            optionFilterProp="label"
            showSearch
            options={companies}
            onChange={(val) => {
              const company = find(get(config, "companies"), ["id", val]);
              setFilters({
                ...filter,
                templateType: undefined,
                company,
                template: undefined,
              });
              setConfig({
                ...config,
                template_types: get(company, "template_access_list"),
                templates: [],
              });
              form.setFieldsValue({
                template: undefined,
                templateType: undefined,
              });
              setStatsConfig(undefined)
            }}
          />
        </Form.Item>
        <Form.Item
          name="templateType"
          label="Template Type"
          colon={false}
          layout="vertical"
        >
          <Select
            style={{ minWidth: 250 }}
            size="middle"
            value={get(filter, "templateType")}
            placeholder="Select Template Type"
            options={map(
              get(config, "template_types"),
              (templateType) => ({
                label: get(templateType, "name"),
                value: get(templateType, "value"),
              })
            )}
            onChange={(value) => {
              setFilters({
                ...filter,
                templateType: value,
                template: undefined,
              });

              getTemplates({
                type: value,
              });
              form.setFieldsValue({
                template: undefined,
              });
              setStatsConfig(undefined)
            }}
          />
        </Form.Item>

        <Form.Item
          name="template"
          label="Template"
          colon={false}
          layout="vertical"
        >
          <Select
            style={{ minWidth: 250 }}
            size="middle"
            placeholder="Select Template"
            options={map(get(config, "templates"), (template) => ({
              label: get(template, "name"),
              value: get(template, "id"),
            }))}
            value={get(filter, "template")}
            onChange={(value) => {
              // const templateId = value;
              setFilters({
                ...filter,
                template: value,
              });
              setStatsConfig(undefined)
              // getDetails(templateId, { from_date: get(filter, "date.0"), to_date: get(filter, "date.1") })
            }}
          />
        </Form.Item>
      </div>
      <div className="justify-end flex items-center w-full h-full space-x-5">
        <Form.Item name="range" label=" " colon={false} layout="vertical">
          <Segmented
            className="bg-gray-200"
            options={[
              { label: "Daily", value: "day" },
              { label: "Weekly", value: "week" },
              { label: "Monthly", value: "month" },
            ]}
            value={get(filter, "interval")}     
             onChange={(interval) => {
              // const date = getCurrentDateRange(interval, dayjs());
              setFilters({
                ...filter,
                interval,
                date: getCurrentDateRange(interval, dayjs()),
              });
              setStatsConfig(undefined)
              // getDetails(get(filter, "template"), { from_date: get(date, "0"), to_date: get(date, "1") })
            }}
            disabled={getButtonDisabled(filter, ["company", 'templateType','template'])}
          />
        </Form.Item>
        <div className="mt-8 ">
          {get(filter, "interval") === "day" && (
            <DatePicker
              onChange={(value) => {
                setFilters({
                  ...filter,
                  date: [dayjs(value).format(dateFormat),
                            dayjs(value).format(dateFormat)]
                });
              setStatsConfig(undefined)
              }}
              style={{ minWidth: 250 }}
              format={'DD-MM-YYYY'}
              showWeek={false}
              value={dayjs(get(filter, "date.0"), "YYYY-MM-DD")}
              picker="date"
            disabled={getButtonDisabled(filter, ["company", 'templateType','template'])}

            />
          )}

          {get(filter, "interval") === "week" && (
            <DatePicker
              onChange={(value) => {
                setFilters({
                  ...filter,
                  date: getCurrentDateRange(get(filter, "interval"), value)
                });
              setStatsConfig(undefined)
              }}
              style={{ minWidth: 250 }}
              format={customWeekStartEndFormat}
              showWeek={false}
              value={dayjs(get(filter, "date.0"), "YYYY-MM-DD")}
              picker="week"
            disabled={getButtonDisabled(filter, ["company", 'templateType','template'])}

            />
          )}

          {get(filter, "interval") === "month" && (
            <DatePicker
              style={{ minWidth: 250 }}
              format={"MM-YYYY"}
                onChange={(value) => {
                setFilters({
                  ...filter,
                  date: getCurrentDateRange(get(filter, "interval"), value)
                });
              setStatsConfig(undefined)
              }}
              value={dayjs(get(filter, "date.0"), "YYYY-MM-DD")}
              picker="month"
            disabled={getButtonDisabled(filter, ["company", 'templateType','template'])}

            />
          )}

        </div>
        <Form.Item name="submit" label=" " colon={false} layout="vertical">
          <Button
            type="primary"
            className="w-30"
            onClick={() => {
              getDetails(get(filter, "template"), { from_date: get(filter, "date.0"), to_date: get(filter, "date.1") })
            }}
            disabled={getButtonDisabled(filter, [
              "templateType",
              "company",
              "date",
            ])}
          >
            Submit
          </Button>
        </Form.Item>
      </div>
    </div>
  );
};

export default HeaderSelector;
